import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
	selector: 'app-resolve-schedule-modal',
	templateUrl: './resolve-schedule-modal.component.html'
})
export class ResolveScheduleModalComponent implements OnInit {
	@Input() schedule: any;
	@Input() vacancy: any;

	constructor(
		public activeModal: NgbActiveModal
	) { }

	ngOnInit() { }
}
